import styled from "@emotion/styled"

export const StyledPageContainer = styled.div`
  padding-top: 10rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
`
